
import Vue from 'vue';

import * as UIStore from '@/store/search/ui';
import * as PatternStore from '@/store/search/form/patterns';
import * as CorpusStore from '@/store/search/corpus';

import { Option } from '@/components/SelectPicker.vue';
import { corpusCustomizations } from '@/utils/customization';

export default Vue.extend({
	props: {
		value: { type: String, required: false },
	},
	computed: {
		model: {
			get(): string | null | undefined { return this.value; },
			set(v: string|null) { this.$emit('input', v); },
		},
		withinOptions(): Option[] {
			const {enabled, elements} = UIStore.getState().search.shared.within;
			return enabled ? elements.filter(element => corpusCustomizations.search.within.includeSpan(element.value)) : [];
		},
		withinAttributes(): Option[] {
			const option = this.value && this.withinOptions.find(o => o.value === this.value);
			if (!option) return [];

			// Which, if any, attribute filter fields should be displayed for this element?
			const availableAttr = Object.keys(CorpusStore.getState().corpus?.relations.spans?.[option.value].attributes ?? {});
			const attr = availableAttr.filter(attrName => corpusCustomizations.search.within.includeAttribute(option.value, attrName))
				.map(a => ({ value: a })) || [];

			return attr.map(el => typeof el === 'string' ? { value: el } : el);
		},
	},
	methods: {
		withinAttributeValue(option: Option) {
			if (this.value === null)
			 	return '';
			const within = PatternStore.getState().shared.withinAttributes;
			return within ? within[option.value] ?? '' : '';
		},
		changeWithinAttribute(option: Option, event: Event) {
			const spanName = this.value;
			if (spanName === null)
				return;
			const el = event.target as HTMLInputElement;
			const curVal = PatternStore.getState().shared.withinAttributes || {};
			curVal[option.value] = el.value;
			PatternStore.actions.shared.withinAttributes(curVal);
		},
	},
})
